var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("travel-service-menu"),
      _c("h3", [
        _vm._v(_vm._s(_vm.$t("settings.travelService.configureEmailSubject")))
      ]),
      _vm._v(" " + _vm._s(_vm.$t("settings.travelService.availableTagsList"))),
      _c("br"),
      _c("b", [_vm._v("{STANDARD}")]),
      _vm._v(
        " - " +
          _vm._s(_vm.$t("settings.travelService.availableTag.standard")) +
          " "
      ),
      _c("br"),
      _c("b", [_vm._v("{ID}")]),
      _vm._v(
        " - " + _vm._s(_vm.$t("settings.travelService.availableTag.id")) + " "
      ),
      _c("br"),
      _c("b", [_vm._v("{CREATED_AT}")]),
      _vm._v(
        " - " +
          _vm._s(_vm.$t("settings.travelService.availableTag.createdAt")) +
          " "
      ),
      _c("br"),
      _c("b", [_vm._v("{CREATED_BY}")]),
      _vm._v(
        " - " +
          _vm._s(_vm.$t("settings.travelService.availableTag.createdBy")) +
          " "
      ),
      _c("br"),
      _c("b", [_vm._v("{PRICE}")]),
      _vm._v(
        " - " +
          _vm._s(_vm.$t("settings.travelService.availableTag.price")) +
          " "
      ),
      _c("br"),
      _vm._v(" {ATTRIBUTE:["),
      _c(
        "span",
        { staticStyle: { "text-decoration": "#0f0f0f line-through" } },
        [_vm._v("example")]
      ),
      _vm._v(
        "]} - " +
          _vm._s(_vm.$t("settings.travelService.availableTag.customAttribute"))
      ),
      _c("br"),
      _vm._l(_vm.additionalParameters, function(parameter) {
        return _c("span", { key: parameter.id }, [
          _c("b", [_vm._v("{ATTRIBUTE:[" + _vm._s(parameter.name) + "]}")]),
          _vm._v(" "),
          _c("br")
        ])
      }),
      _c("v-text-field", {
        model: {
          value: _vm.subjectMask,
          callback: function($$v) {
            _vm.subjectMask = $$v
          },
          expression: "subjectMask"
        }
      }),
      _c(
        "v-row",
        { staticClass: "mb-4" },
        [
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              staticClass: "mr-3",
              attrs: {
                disabled: _vm.$store.getters["Ajax/loading"],
                color: "success"
              },
              on: { click: _vm.saveCurrentCustomSubject }
            },
            [_vm._v(_vm._s(_vm.$t("global.save")))]
          )
        ],
        1
      ),
      _c(
        "v-alert",
        {
          attrs: {
            value: _vm.subjectMask == null || _vm.subjectMask.length === 0,
            color: "info",
            icon: "info",
            dark: ""
          }
        },
        [
          _vm._v(
            " " +
              _vm._s(_vm.$t("settings.travelService.standardSubjectAlert")) +
              " "
          )
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }